import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as n, createElementBlock as l, normalizeClass as s, createElementVNode as d } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconListChevronsUpDown",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(r).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, m = ["aria-label", "data-qa", "aria-hidden"];
function h(e, t, i, u, _, a) {
  return n(), l("svg", {
    "aria-label": i.ariaLabel,
    class: s([a.iconSizeClass, "d-icon d-icon--list-chevrons-up-down"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "List Chevrons Up Down",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...t[0] || (t[0] = [
    d("path", {
      d: "M5.5 9a.5.5 0 0 1 0 1h-4a.5.5 0 1 1 0-1h4Zm4.646-1.354a.5.5 0 1 1 .707.707l-1.5 1.5a.5.5 0 0 1-.707 0l-1.5-1.5a.5.5 0 1 1 .708-.707L9 8.793l1.146-1.147ZM5.5 5.5a.5.5 0 0 1 0 1h-4a.5.5 0 1 1 0-1h4Zm3.225-3.418a.5.5 0 0 1 .629.064l1.5 1.5a.5.5 0 1 1-.707.707L9 3.207 7.854 4.353a.5.5 0 1 1-.708-.707l1.5-1.5.079-.064ZM5.5 2a.5.5 0 0 1 0 1h-4a.5.5 0 1 1 0-1h4Z",
      fill: "currentColor"
    }, null, -1)
  ])], 10, m);
}
const w = /* @__PURE__ */ o(c, [["render", h]]);
export {
  w as default
};
//# sourceMappingURL=list-chevrons-up-down.js.map
